import { styled } from "@mui/system";
import { imageFormatUrl } from "../utils";

const Img = styled("img")`
  max-height: 100%;
  width: 100%;
  object-fit: contain;
  // object-fit: cover;
  vertical-align: bottom;
  max-width: 300px;
  height: 100%;
  justify-self: center;
  align-self: center;
`;

export const ImageListItem = ({ item, ...rest  }) => {
  const { crossOrigin = null } = rest;
  if (crossOrigin) {
    return (
      <Img 
        src={imageFormatUrl(item.media, "small")} 
        alt={item.title}
        crossOrigin={crossOrigin}
        referrerPolicy="no-referrer"
      />
    );
  }
  return (
    <Img 
      src={imageFormatUrl(item.media, "small")} 
      alt={item.title}
    />
  );
    // crossOrigin="anonymous"
    // referrerPolicy="no-referrer"
};
export default ImageListItem;
